import { render, staticRenderFns } from "./ExpertAdd.vue?vue&type=template&id=177fc166&scoped=true"
import script from "./ExpertAdd.vue?vue&type=script&lang=ts"
export * from "./ExpertAdd.vue?vue&type=script&lang=ts"
import style0 from "./ExpertAdd.vue?vue&type=style&index=0&id=177fc166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fc166",
  null
  
)

export default component.exports